<template>
  <ts-card>
    <div
      class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
    >
      <h4 class="ts-text-sm">{{ $t('teacherSubjectCode.pageTitle') }}</h4>
      <ts-modal-close-button />
    </div>
    <ts-card-wrapper>
      <ts-loading-banner :loading="loadingPreData">
        <form class="form-horizontal">
          <div class="row form-group m-b-15">
            <label class="col-form-label col-md-3 required">{{
              $t('teacherSubjectCode.teacherName')
            }}</label>
            <div class="col-md-7">
              <treeselect
                :options="
                  teachers.map(i => ({
                    id: i.teacher_id,
                    label: i.lname_foreign + ' ' + i.fname_foreign
                  }))
                "
                :placeholder="$t('typeForSearch')"
                v-model="model.teacher_id"
                :maxHeight="120"
                :clearable="false"
                disabled
              ></treeselect>
              <div class="validate" v-if="errors.has('teacher_id')">
                {{ errors.first('teacher_id') }}
              </div>
            </div>
          </div>
          <div class="row form-group m-b-15">
            <label class="col-form-label col-md-3 required">{{
              $t('teacherSubjectCode.subjectName')
            }}</label>
            <div class="col-md-7">
              <treeselect
                :options="
                  subjects.map(el => ({
                    id: el.subject_id,
                    label: el.subject_name_foreign
                  }))
                "
                :placeholder="$t('typeForSearch')"
                v-model="model.subject_id"
                :maxHeight="120"
                :clearable="false"
                disabled
              ></treeselect>
              <div class="validate" v-if="errors.has('teacher_id')">
                {{ errors.first('teacher_id') }}
              </div>
            </div>
          </div>
          <div class="row form-group m-b-15">
            <label class="col-form-label col-md-3 required">{{
              $t('teacherSubjectCode.subjectCode')
            }}</label>
            <div class="col-md-7">
              <input
                type="text"
                v-model="model.subject_code"
                class="form-control"
                :class="{ 'is-invalid': errors.has('subject_code') }"
              />
              <div class="invalid-feedback" v-if="errors.has('subject_code')">
                {{ errors.first('subject_code') }}
              </div>
            </div>
          </div>
          <div class="row">
            <label class="col-form-label col-md-3 required">{{
              $t('teacherSubjectCode.totalHour')
            }}</label>
            <div class="col-md-7">
              <input
                type="number"
                v-model.number="model.total_hours"
                class="form-control"
                :class="{ 'is-invalid': errors.has('total_hours') }"
              />
              <div class="invalid-feedback" v-if="errors.has('total_hours')">
                {{ errors.first('total_hours') }}
              </div>
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-sm-12 text-right">
              <ts-button class="btn-default" @click.prevent="$emit('close')">{{
                $t('cancel')
              }}</ts-button>
              <ts-button
                class="btn-primary ml-2"
                @click.prevent="update"
                :waiting="saving"
                >{{ $t('update') }}</ts-button
              >
            </div>
          </div>
        </form>
      </ts-loading-banner>
    </ts-card-wrapper>
  </ts-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'teacher-subject-code-edit',
  props: ['editData'],
  data() {
    return {
      model: {
        teacher_id: null,
        subject_id: null,
        subject_code: null,
        total_hours: ''
      },
      errors: new Errors(),
      saving: false,
      loadingPreData: false
    }
  },
  created() {
    this.loadingPreData = true
    Promise.all([this.fetchTeachers()]).then(() => {
      this.loadingPreData = false
      this.setEditData()
    })
  },
  computed: {
    ...mapState('teacherSubjectCode', ['teachers', 'subjects'])
  },
  methods: {
    ...mapActions('teacherSubjectCode', ['fetchTeachers']),
    setEditData() {
      if (!_.isEmpty(this.editData)) {
        this.getSubjectByTeacher(this.editData.teacher_id)
        this.model = {
          teacher_id: this.editData.teacher_id,
          subject_id: this.editData.subject_id,
          subject_code: this.editData.subject_code,
          total_hours: this.editData.total_hours
        }
      }
    },
    async getSubjectByTeacher(teacher_id) {
      this.errors = new Errors()
      if (!teacher_id) {
        return
      }
      await this.$store
        .dispatch('teacherSubjectCode/subject', teacher_id)
        .then(() => {})
        .catch(error => {
          this.ready_fetch = false
          this.$toasted.error(error.message)
        })
    },
    update() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('teacherSubjectCode/update', {
          sstc_id: this.editData.sstc_id,
          ...this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.saving = false
          this.$emit('close')
        })
        .catch(error => {
          this.saving = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    }
  }
}
</script>
